import * as React from 'react';
import './badge.scss';

interface Props {
  text: string;
  type?: string;
  warning?: boolean;
}

const Badge: React.FunctionComponent<Props> = ({ text, type, warning = false }) => {
  if (type === 'type2' || warning) {
    return <div className="badge2">{text}</div>;
  }
  return <div className="badge">{text}</div>;
};
export default Badge;
